import { Pressable } from "react-native";

import { Col, Icon, Row, TextBody } from "../lib";
import { formatDate } from "../services";
import { Tag } from "./tag";
import { PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  createdAt: Date;
  published: boolean;
  onDelete: () => void;
  variant: "video" | "image";
}>;

export function TimelineListItemFooter({
  children,
  createdAt,
  published,
  onDelete,
  variant,
}: Props) {
  return (
    <Col px="4" py="2">
      {!!children && <Col mb="4">{children}</Col>}

      <Row.LR>
        <Row.L mr="4">
          <Col mr="2">
            <Icon name={variant === "video" ? "video" : "image"} />
          </Col>
          <TextBody color="onSurfaceDim" mr="2">
            {formatDate(createdAt)}
          </TextBody>
          <Tag
            label={published ? "Published" : "Pending approval"}
            variant={published ? "success" : "warning"}
          />
        </Row.L>

        {!!published && (
          <Pressable onPress={onDelete}>
            <Icon name="delete-outline" color="onError" />
          </Pressable>
        )}
      </Row.LR>
    </Col>
  );
}
